import { FilteredCreditApplication, Loader, useMerchantById } from '@applyonline/shared'
import { t } from '@if/core/i18n'
import { EDecision } from '@if/core/types'
import ApprovedPrequalForm from './components/ApprovedPrequalForm'
import DeclinedPrequalForm from './components/DeclinedPrequalForm'
import FailedToObtainCreditReportForm from './components/FailedToObtainCreditReportForm'

interface Props {
  creditApp: FilteredCreditApplication
}

const PrequalResultPage = ({ creditApp }: Props) => {
  const decision = creditApp.prequalificationDecision?.decision
  const applicantHasReport = creditApp.applicant.hasCreditReport
  const coapplicantHasReport = creditApp.coapplicant?.hasCreditReport ?? true

  const [merchant, isLoadingMerchant] = useMerchantById(creditApp.merchantId, creditApp.financingProgramId)
  if (isLoadingMerchant || !merchant || merchant === undefined)
    return <Loader title={t('common.withYouShortly')} description={t('common.pleaseWait')} />

  return (
    <div>
      {decision === EDecision.Approved && <ApprovedPrequalForm creditApp={creditApp} merchant={merchant} />}
      {decision === EDecision.Refused && applicantHasReport && coapplicantHasReport && (
        <DeclinedPrequalForm creditApp={creditApp} />
      )}
      {decision === EDecision.Refused && (!applicantHasReport || !coapplicantHasReport) && (
        <FailedToObtainCreditReportForm creditApp={creditApp} />
      )}
    </div>
  )
}

export default PrequalResultPage
